export function calculateAverageApy(data: { balanceUsd: number; apy: number; indicator?: string }[]): number {
  const totalBalance = data.reduce((acc, { balanceUsd }) => acc + balanceUsd, 0)
  if (totalBalance === 0) {
    return 0
  }

  const weightedSum = data.reduce((acc, { balanceUsd, apy }) => {
    const product = balanceUsd * apy
    return acc + product
  }, 0)

  return weightedSum / totalBalance
}
